import {
    initialRequestProgressState,
    initialRequestsProgressState,
    RequestProgressState,
    RequestState,
    RequestStatus,
} from './RequestProgressState';
import { RequestProgressAction, RequestProgressActionType } from './actions';
import { Reducer } from 'redux';
import { addItemToArrayWithMaxSize } from 'utils/arrays/arrayUtils';

export const requestProgressReducer: Reducer<
    RequestProgressState,
    RequestProgressAction
> = (state = initialRequestsProgressState, action) => {
    switch (action.type) {
        case RequestProgressActionType.REQUEST_PROGRESS_SET_IN_PROGRESS:
            return reduceRequestProgress(state, action.payload!.key, {
                status: RequestStatus.IN_PROGRESS,
            });

        case RequestProgressActionType.REQUEST_PROGRESS_SET_SUCCESS:
            return reduceRequestProgress(state, action.payload!.key, {
                status: RequestStatus.SUCCESS,
            });
        case RequestProgressActionType.REQUEST_PROGRESS_SET_ERROR: {
            return reduceRequestProgress(state, action.payload!.key, {
                status: RequestStatus.ERROR,
                errorDetails: {
                    statusCode: action.payload!.statusCode,
                    data: action.payload!.data,
                    message: action.payload!.message,
                },
            });
        }

        case RequestProgressActionType.REQUEST_PROGRESS_ADD_REQUEST: {
            const prevState =
                state[action.payload!.key] || initialRequestProgressState;
            const nextRequests = addItemToArrayWithMaxSize(
                action.payload!.requestInfo,
                prevState.requests,
                10
            );
            return reduceRequestProgress(state, action.payload!.key, {
                requests: nextRequests,
            });
        }
        case RequestProgressActionType.REQUEST_PROGRESS_ADD_RESPONSE: {
            const prevState =
                state[action.payload!.key] || initialRequestProgressState;
            const prevRequest = prevState.requests.find(
                (r) => r.id === action.payload!.requestId
            );
            if (!prevRequest) {
                return state;
            }
            const nextRequest = {
                ...prevRequest,
                response: action.payload!.responseInfo,
            };
            const nextRequests = [
                nextRequest,
                ...prevState.requests.filter(
                    (r) => r.id !== action.payload!.requestId
                ),
            ];
            return reduceRequestProgress(state, action.payload!.key, {
                requests: nextRequests,
            });
        }
    }
    return state!;
};

function reduceRequestProgress(
    state: RequestProgressState,
    key: string,
    delta: Partial<RequestState>
): RequestProgressState {
    const prevState = state[key] || initialRequestProgressState;
    const newState = { ...prevState, ...delta };
    return { ...state, [key]: newState };
}
